import getDisplayName from "./utils/getDisplayName";
export function wrapDisplayName(name) {
    return {
        staticCallback: function (componentClass, target) {
            componentClass["displayName"] = name + "(" + getDisplayName(target) + ")";
        },
    };
}
export default wrapDisplayName;

//# sourceMappingURL=wrapDisplayName.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/wrapDisplayName.js
// module id = 193
// module chunks = 0